import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import {
  NavigationItem,
  navigationItemsWithPatientAndInterview,
} from '../../models/navigation-item-model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import {
  InterviewNotes,
  LabelAndDescription,
  PatientAppointment,
  PatientEssentialInfo,
} from '../../models/patient-model';
import {
  mockedHumorList,
  mockedImportantTopicList,
  mockedSignificantEventsList,
  mockedSymptomsSignsList,
} from '../../models/mocked-data';
import { LabelService } from '../../services/label.service';
import { FormsModule } from '@angular/forms';
import { InterviewNotesComponent } from '../../sections/interview-notes/interview-notes.component';
import { InterviewAiTopicComponent } from '../../sections/interview-ai-topic/interview-ai-topic.component';
import { AiService } from '../../services/ai.service';
import {
  AIAppointmentPipelineStatus,
  AppointmentAiState,
  NuclearTopicsDistrEnriched,
  WordCloudData,
} from '../../models/ai-model';
import { catchError, filter, of, Subject, switchMap, takeUntil } from 'rxjs';
import { ErrorPanelService } from '../../services/error-panel.service';
import { SidebarService } from '../../services/sidebar.service';
import { pages } from '../../shared/labels';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import {
  interviewDetails_aiTopic_infoText,
  interviewDetails_nuclearTopic_infoText,
  interviewDetails_summary_infoText,
  interviewDetails_wordcloud_infoText,
} from '../../models/descriptions/info-texts/info-texts';
import { PdfExportService } from '../../services/pdf-export.service';
@Component({
  selector: 'app-interview-details',
  standalone: true,
  imports: [
    SharedModule,
    FormsModule,
    InterviewNotesComponent,
    InterviewAiTopicComponent,
    MatIconModule,
    MatChipsModule,
  ],
  templateUrl: './interview-details.component.html',
  styleUrl: './interview-details.component.scss',
})
export class InterviewDetailsComponent implements OnInit {
  navigationItems: NavigationItem[] = [];
  appointment: PatientAppointment = {
    id: '',
    patient_id: '',
    date: '',
    start_time: '',
    title: '',
  };
  appointmentId: string = '';
  patientFirstName: string = '';
  patientLastName: string = '';
  name_title_date: string = '';
  name: string = '';
  notesSelected: string = 'not-selected';
  topicSelected: string = 'selected';
  aiSummarySelected: string = 'ai-section-selected';
  isLoadingAiSummary: boolean = true;
  aiCategoriesDistributionSelected: string = 'ai-section-not-selected';
  isLoadingAiCategoriesDistribution: boolean = true;
  aiWordcloudsSelected: string = 'ai-section-not-selected';
  isLoadingAiWordclouds: boolean = true;
  aiTopicSelected: string = 'ai-section-not-selected';
  isLoadingAiTopic: boolean = true;
  interviewNotes: InterviewNotes[] = [];
  appointmentTitle: string = '';
  humorNotes: string[] = mockedHumorList;
  significantEventsNotes: string[] = mockedSignificantEventsList;
  importantTopicNotes: string[] = mockedImportantTopicList;
  symptomnsAndSignsNotes: string[] = mockedSymptomsSignsList;
  selectedNotesArray: string[] = [];
  selectedNotesCategory: string = '';
  showAddNotePanel: boolean = false;

  nuclearTopicsDistrEnriched: NuclearTopicsDistrEnriched = {
    date: '',
    title: '',
    categories_distribution_available: false,
    categories_distribution: null,
  };

  hasModifyButtonBeenClicked: boolean = false;
  modifyButtonText: string = 'edit';
  showEditMoodPanel: boolean = false;
  inputBoxesForMoodPanel: LabelAndDescription[] = [];

  showInfoPanel: boolean = false;
  infoTitle: string = interviewDetails_summary_infoText.title;
  infoText: string = interviewDetails_summary_infoText.text;

  isMobile = window.innerWidth < 930;
  isMobilePortrait = window.innerWidth < 730;

  appSumm: string = '';

  appAiState!: AppointmentAiState;

  topicsForWordclouds = [];
  wordCloudData: WordCloudData[] = [];
  patientId: any;

  isEditing: boolean = false;

  toggleEdit(): void {
    this.isEditing = !this.isEditing;
  }

  constructor(
    private router: Router,
    private patientService: PatientService,
    public labelService: LabelService,
    private aiService: AiService,
    public errorPanelService: ErrorPanelService,
    private route: ActivatedRoute,
    private sidebarService: SidebarService,
    private cdRef: ChangeDetectorRef,
    private pdfExportService: PdfExportService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.patientService
        .getPatientEssentialInfo(params['patientId'])
        .subscribe({
          next: (data: PatientEssentialInfo) => {
            this.patientId = data.id;
            this.patientFirstName = data.first_name;
            this.patientLastName = data.last_name;

            this.appointmentId = params['appointmentId'];
            this.patientService.getAppointment(this.appointmentId).subscribe({
              next: (appointment) => {
                this.appointment = appointment;
                this.appointmentTitle = appointment.title;
                if (
                  this.appointmentTitle
                    .toLowerCase()
                    .includes(
                      `${this.patientFirstName.toLowerCase()} ${this.patientLastName.toLowerCase()}:`
                    )
                ) {
                  this.appointmentTitle = this.appointmentTitle.split(': ')[1];
                }
                this.navigationItems =
                  this.sidebarService.updateNavigationItems(
                    navigationItemsWithPatientAndInterview,
                    this.patientFirstName,
                    this.patientLastName,
                    this.patientId,
                    pages.interviewDetails,
                    this.appointmentId,
                    this.appointmentTitle
                  );

                this.name_title_date = `${this.patientFirstName} ${this.patientLastName} - ${this.appointmentTitle} - ${this.appointment.date}`;
                this.getAiState();
              },
            });
          },

          error: (err) => {
            console.error('Error getting patient essential info:', err);
            this.errorPanelService.showErrorSnackBar(
              'Errore nel recuperare i dati del paziente'
            );
          },
        });
    });

    this.updateSelectedSection();

    // Ascolta gli eventi di navigazione per aggiornare la selezione quando cambia l'URL
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateSelectedSection();
      });
  }

  getAiState() {
    this.aiService.getAppointmentAiStatus(this.appointment.id).subscribe({
      next: (response) => {
        this.appAiState = response;

        if (this.appAiState.appsumm_state === 'EXECUTED') {
          this.getAppSumm();
        } else {
          this.isLoadingAiSummary = false;
        }

        if (this.appAiState.catdistr_state === 'EXECUTED') {
          this.getNuclearTopicsDistrEnriched();
        } else {
          this.isLoadingAiCategoriesDistribution = false;
        }
        if (this.appAiState.apptopics_state === 'EXECUTED') {
          this.getAiTopics();
        } else {
          this.isLoadingAiTopic = false;
        }
        if (this.appAiState.appwordcloud_state === 'EXECUTED') {
          this.getWordCloudData();
        } else {
          this.isLoadingAiWordclouds = false;
        }
      },
      error: (err) => {
        console.error('Errore nel recuperare lo stato della pipeline', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare lo stato della pipeline'
        );
      },
    });
  }

  getAiTopics() {
    this.aiService.getAiTopicAppointment(this.appointment.id).subscribe({
      next: (response) => {
        this.topicsForWordclouds = response;
        this.isLoadingAiTopic = false;
      },
      error: (err) => {
        console.error('Errore nel recuperare i topic', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare i topic'
        );
        this.isLoadingAiTopic = false;
      },
    });
  }

  getAppSumm() {
    this.aiService.getAppSumm(this.appointment.id).subscribe({
      next: (response) => {
        this.appSumm = response;
        this.isLoadingAiSummary = false;
      },
      error: (err) => {
        console.error('Errore nel recuperare il riassunto', err);
        this.isLoadingAiSummary = false;
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare il riassunto'
        );
      },
    });
  }

  displayTranscriptionSection() {
    this.notesSelected = 'not-selected';
    this.topicSelected = 'not-selected';
  }

  displayAiSection(section: string) {
    switch (section) {
      case 'AppSumm':
        this.aiSummarySelected = 'ai-section-selected';
        this.aiCategoriesDistributionSelected = 'ai-section-not-selected';
        this.aiWordcloudsSelected = 'ai-section-not-selected';
        this.aiTopicSelected = 'ai-section-not-selected';
        this.infoTitle = interviewDetails_summary_infoText.title;
        this.infoText = interviewDetails_summary_infoText.text;
        this.router.navigate([
          '/pazienti',
          this.patientId,
          'appointments',
          this.appointment.id,
          'ai',
          'summary',
        ]);
        break;
      case 'Categories':
        this.aiSummarySelected = 'ai-section-not-selected';
        this.aiCategoriesDistributionSelected = 'ai-section-selected';
        this.aiWordcloudsSelected = 'ai-section-not-selected';
        this.aiTopicSelected = 'ai-section-not-selected';
        this.infoTitle = interviewDetails_nuclearTopic_infoText.title;
        this.infoText = interviewDetails_nuclearTopic_infoText.text;
        this.router.navigate([
          '/pazienti',
          this.patientId,
          'appointments',
          this.appointment.id,
          'ai',
          'nuclear-topic',
        ]);
        break;
      case 'Wordclouds':
        this.aiSummarySelected = 'ai-section-not-selected';
        this.aiCategoriesDistributionSelected = 'ai-section-not-selected';
        this.aiWordcloudsSelected = 'ai-section-selected';
        this.aiTopicSelected = 'ai-section-not-selected';
        this.infoTitle = interviewDetails_wordcloud_infoText.title;
        this.infoText = interviewDetails_wordcloud_infoText.text;
        this.router.navigate([
          '/pazienti',
          this.patientId,
          'appointments',
          this.appointment.id,
          'ai',
          'wordcloud',
        ]);
        break;
      case 'AiTopic':
        this.aiSummarySelected = 'ai-section-not-selected';
        this.aiCategoriesDistributionSelected = 'ai-section-not-selected';
        this.aiWordcloudsSelected = 'ai-section-not-selected';
        this.aiTopicSelected = 'ai-section-selected';
        this.infoTitle = interviewDetails_aiTopic_infoText.title;
        this.infoText = interviewDetails_aiTopic_infoText.text;
        this.router.navigate([
          '/pazienti',
          this.patientId,
          'appointments',
          this.appointment.id,
          'ai',
          'aitopic',
        ]);
        break;
    }
  }

  getNuclearTopicsDistrEnriched() {
    this.aiService
      .getNuclearTopicsDistrEnriched(this.appointment.id)
      .subscribe({
        next: (response: NuclearTopicsDistrEnriched) => {
          this.nuclearTopicsDistrEnriched = response;
          this.isLoadingAiCategoriesDistribution = false;
        },
        error: (err) => {
          console.error('Errore nel recuperare le categorie', err);
          this.isLoadingAiCategoriesDistribution = false;
          this.errorPanelService.showErrorSnackBar(
            'Errore nel recuperare le categorie'
          );
        },
      });
  }

  getWordCloudData() {
    this.aiService.getWordCloudData(this.appointment.id).subscribe({
      next: (response) => {
        this.wordCloudData = response;
        this.isLoadingAiWordclouds = false;
      },
      error: (err) => {
        console.error('Errore nel recuperare la wordcloud', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare la wordcloud'
        );
        this.isLoadingAiWordclouds = false;
      },
    });
  }

  downloadTranscription() {
    this.aiService.getTranscription(this.appointment.id).subscribe({
      next: (blob: Blob) => {
        const fileName = this.appointment.title + '.pdf';
        this.downloadFile(blob, fileName);
      },
      error: (err) => {
        console.error('Errore nel download della trascrizione', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel download della trascrizione'
        );
      },
    });
  }

  downloadFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob); // Crea un URL per il Blob
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // Imposta il nome del file per il download
    document.body.appendChild(a); // Aggiunge l'elemento 'a' al corpo del documento
    a.click(); // Simula un click per scaricare il file
    document.body.removeChild(a); // Rimuove l'elemento 'a' dopo il download
    window.URL.revokeObjectURL(url); // Pulisce l'URL del Blob
  }

  onModifyButtonClick(): void {
    if (this.modifyButtonText === 'save') {
      this.patientService
        .putAppointment(this.appointment.id, this.appointment)
        .subscribe({
          next: (response) => {
            console.log('Appuntamento modificato con successo');
          },
          error: (error) => {
            console.error('Qualcosa è andato storto', error);
            this.errorPanelService.showErrorSnackBar(
              "Errore nel modificare l'appuntamento"
            );
          },
        });
    }
    this.hasModifyButtonBeenClicked = !this.hasModifyButtonBeenClicked;
    if (this.hasModifyButtonBeenClicked) {
      this.modifyButtonText = 'save';
    } else {
      this.modifyButtonText = 'edit';
    }
  }

  displayNotesSection() {
    this.router
      .navigate([
        '/pazienti',
        this.patientId,
        'appointments',
        this.appointment.id,
        'notes',
      ])
      .then(() => {
        this.updateSelectedSection();
      });
  }

  displayTopicSection() {
    this.router
      .navigate([
        '/pazienti',
        this.patientId,
        'appointments',
        this.appointment.id,
        'ai',
      ])
      .then(() => {
        this.updateSelectedSection();
      });
  }

  updateSelectedSection() {
    const currentUrl = this.router.url;
    this.notesSelected = currentUrl.includes('/notes')
      ? 'selected'
      : 'not-selected';
    this.topicSelected = currentUrl.includes('/ai')
      ? 'selected'
      : 'not-selected';

    this.aiSummarySelected = currentUrl.includes('/ai/summary')
      ? 'ai-section-selected'
      : 'ai-section-not-selected';
    this.aiCategoriesDistributionSelected = currentUrl.includes(
      '/ai/nuclear-topic'
    )
      ? 'ai-section-selected'
      : 'ai-section-not-selected';
    this.aiWordcloudsSelected = currentUrl.includes('/ai/wordcloud')
      ? 'ai-section-selected'
      : 'ai-section-not-selected';
    this.aiTopicSelected = currentUrl.includes('/ai/aitopic')
      ? 'ai-section-selected'
      : 'ai-section-not-selected';

    this.cdRef.detectChanges(); // Assicurati di forzare il rilevamento delle modifiche
  }

  toggleAddNotePanel(note: InterviewNotes) {
    this.showAddNotePanel = true;
    this.selectedNotesCategory = note.categoria;
    switch (note.categoria) {
      case 'Umore': {
        this.selectedNotesArray = this.humorNotes;
        break;
      }
      case 'Eventi significativi': {
        this.selectedNotesArray = this.significantEventsNotes;
        break;
      }
      case 'Topic importanti': {
        this.selectedNotesArray = this.importantTopicNotes;
        break;
      }
      case 'Sintomi e segni': {
        this.selectedNotesArray = this.symptomnsAndSignsNotes;
        break;
      }
      default: {
        this.selectedNotesArray = [];
      }
    }
  }

  closeAddNotePanel() {
    this.showAddNotePanel = false;
  }
  confirmAddNotePanel() {
    //here to add api calls
    this.showAddNotePanel = false;
  }

  navigateToAiPage() {
    this.router.navigate([`/analisi-ai/${this.patientId}`]);
  }

  toggleInfoPanel() {
    this.showInfoPanel = !this.showInfoPanel;
  }

  downloadPDF() {
    if (typeof window !== 'undefined') {
      let filename = this.name_title_date;
      if (this.aiSummarySelected === 'ai-section-selected') {
        filename = filename + ' - Sintesi Colloquio';
      }
      if (this.aiCategoriesDistributionSelected === 'ai-section-selected') {
        filename = filename + ' - Topic Nucleari';
      }
      if (this.aiWordcloudsSelected === 'ai-section-selected') {
        filename = filename + ' - Wordcloud';
      }
      if (this.aiTopicSelected === 'ai-section-selected') {
        filename = filename + ' - AI Topic';
      }

      if (this.aiCategoriesDistributionSelected === 'ai-section-selected') {
        void this.pdfExportService.exportNuclearTopicsPdf({
          filename,
          distribution: this.nuclearTopicsDistrEnriched.categories_distribution,
          subtitle: this.name_title_date,
        });
        return;
      }

      import('html2pdf.js').then((html2pdf) => {
        const element = document.querySelector<HTMLElement>(
          'app-interview-ai-topic'
        );
        if (!element) {
          console.error('PDF source element not found');
          return;
        }

        const options = {
          margin: 0.5,
          filename: filename,
          image: { type: 'jpeg' as const, quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: {
            unit: 'in' as const,
            format: 'letter' as const,
            orientation: 'portrait' as const,
          },
        };

        html2pdf
          .default()
          .from(element)
          .set(options)
          .toPdf()
          .get('pdf')
          .then((pdf: import('jspdf').jsPDF) => {
            this.pdfExportService.applyAiExportMarking(pdf, {
              title: filename,
            });
            pdf.save(filename);
          });
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
    this.isMobilePortrait = window.innerWidth < 730;
  }

  onSummaryChange(newSummary: string): void {
    if (!this.appointmentId) {
      console.error('No appointment ID available');
      return;
    }

    this.appSumm = newSummary;
    this.aiService.updateAppSumm(this.appointmentId, newSummary).subscribe({
      next: () => {
        console.log('Summary updated successfully');
      },
      error: (error) => {
        console.error('Error updating summary:', error);
        this.errorPanelService.showErrorSnackBar('Error updating summary');
      },
    });
  }
}
